import { get } from '../../utils/object-helpers';

export default class {
    onInput(input) {
        const saveAction = get(input, 'page.modules.PRESENCE_INFORMATION_MODULE.saveAction', null);
        return {
            config: saveAction
        };
    }
}
